<template>
  <div v-if="password" class="text-center">
    <span class="icon-click" @click="toggleShowPassword">
      <span v-if="showPassword" class="text-danger">
        {{ password }}
      </span>
      <font-awesome-icon v-else icon="eye-slash" />
    </span>
  </div>
  <div v-else class="text-center">
    <b-badge variant="light">
      L'utilisateur a changé <br />
      son mot de passe
    </b-badge>
  </div>
</template>

<script>
export default {
  props: {
    password: {
      type: String,
      default: "",
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleShowPassword() {
      this.$emit("toggleShowPassword");
    },
  },
};
</script>
